import { html } from "../lib/bind";

export type CategoryRulesSubNavActive = "categories" | "rules";

const ITEMS: { key: CategoryRulesSubNavActive; path: string; label: string }[] = [
  { key: "categories", path: "/categories", label: "Categories" },
  { key: "rules", path: "/category-rules", label: "Category rules" },
];

/** Shared sub-nav for the Categories / Category rules pages (mirrors
 * buildBankingSubNav's pattern exactly) — each page's header shows a grey button
 * linking to the other page only, so the active page's own button never appears as a
 * dead self-link. */
export function buildCategoryRulesSubNav(active: CategoryRulesSubNavActive): Node {
  const fragment = html`<div class="page-header">
    <div class="invoice-actions"></div>
  </div>`;
  const actions = fragment.querySelector(".invoice-actions");
  if (!actions) throw new Error("category-rules subnav produced no element");
  for (const item of ITEMS) {
    if (item.key === active) continue;
    const link = document.createElement("a");
    link.href = item.path;
    link.dataset.link = "";
    link.className = "btn";
    link.textContent = item.label;
    actions.appendChild(link);
  }
  return fragment;
}
